export const faqData = [
  {
    id: 'faq-1',
    question: 'Are all projects verified and legally approved?',
    answer: 'Yes, every project we market undergoes thorough legal verification. We only work with societies that have all necessary NOCs and approvals from relevant development authorities. Our legal team cross-checks all documentation before listing any project.',
  },
  {
    id: 'faq-2',
    question: 'Can overseas Pakistanis invest without visiting Pakistan?',
    answer: 'Absolutely. We provide complete remote assistance for overseas Pakistani investors. This includes virtual site tours, digital document submission, secure payment processing, and power of attorney arrangements. Our team keeps you updated at every step.',
  },
  {
    id: 'faq-3',
    question: 'What payment plans are available?',
    answer: 'We offer flexible payment plans tailored to your budget. Most projects offer installment plans spread over 12 to 36 months with a down payment starting from 20%. Some projects also offer balloon payment options and deferred payment structures.',
  },
  {
    id: 'faq-4',
    question: 'What is the booking process?',
    answer: 'The booking process is simple: (1) Contact us via WhatsApp or call to discuss your requirements, (2) Choose your plot or property, (3) Submit required documents (CNIC copies, photos, etc.), (4) Pay the booking amount, (5) Receive your allotment letter and payment schedule.',
  },
  {
    id: 'faq-5',
    question: 'Do you provide site visit assistance?',
    answer: 'Yes, we arrange complimentary site visits for all serious buyers. Our team will pick you up, take you to the project site, explain the master plan, show you available plots, and answer all your questions on the spot.',
  },
  {
    id: 'faq-6',
    question: 'How does Sunshine Real Estate charge for its services?',
    answer: 'We charge a transparent and competitive service fee that is disclosed upfront. There are no hidden charges. For buyers, our fee is typically a percentage of the property value. For sellers and developers, we offer customized marketing packages.',
  },
  {
    id: 'faq-7',
    question: 'Can I resell my property through Sunshine?',
    answer: 'Yes, we offer complete resale and property transfer services. We help you find buyers, handle negotiations, manage documentation, and ensure a smooth transfer process. Our extensive client network helps properties sell faster.',
  },
];